<template>
    <v-select bg-color="#21242C" :items="sortOptions" item-title="label" item-value="value" variant="solo"
        density="compact" :menu-props="{
            contentClass: 'select-background-color',
            eager: true,
            maxHeight: 'auto',
            closeOnContentClick: true,
            openDelay: 0,
            closeDelay: 0
        }" v-model="offerStore.offersParameters.sort_by" hide-details>
    </v-select>
</template>

<script>
import { computed } from 'vue';
import { OfferStore } from '@/store/offerStore';

export default {
    name: "OfferSortOptions",
    setup() {
        const offerStore = OfferStore();
        const sortOptions = computed(() => offerStore.offerSortOptions);
        return { offerStore, sortOptions: sortOptions };
    },
};
</script>
